import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { DocumentCardData, DocumentCardType } from '../../../models/document-card-data.model';
import { DwCardBaseComponent, DwComponent, DwComponentType, DwMediaRepositoryService, DwMetaDataListCardConfigData, DwMetaDataRoutingService, DwQueryMetaData } from '@devwareapps/devware-cap';
import { AppMetaDataItemNames, DocumentFolderEntity, DocumentGroupEntity, DocumentItemEntity, DocumentItemsListQueryEntity } from '../../../../../meta-data/app-meta-data.service';
import { DocumentSheetService } from '../../../services/document-sheet.service';
import { AdminManagerService } from '../../../../admin/services/admin-manager.service';
import { DocumentsManagerService } from '../../../services/documents-manager.service';

@Component({
  selector: 'app-document-card',
  templateUrl: './document-card.component.html',
  styleUrls: ['./document-card.component.scss'],
 // encapsulation: ViewEncapsulation.None

})
export class DocumentCardComponent implements DwCardBaseComponent<any, DocumentCardData>, OnInit, OnChanges {
  cardConfig?: any;
  @Input() data?: DocumentCardData;
  @Input() parentFolder?: DocumentFolderEntity;
  @Input() documentGroup?: DocumentGroupEntity;
  @Input() isSelected: boolean = false;
  @Output() cardClick = new EventEmitter<DocumentCardData>();
  @Output() cardConfigureClick = new EventEmitter<DocumentCardData>();

  resolvedContext?: any;
  queryMetaData?: DwQueryMetaData;
  imageClass: string;
  imageUrl: string;
  iconCss: string;
  pdfIconMaxSize: string = null;

  canEditItem: boolean = false;

  // // Getter to check if this card is the selected one
  // get isSelected(): boolean {
  //   return false;
  //   //return DocumentCardComponent.selectedId === this.data?.DocumentItemId;
  // } 

  constructor(
    private dwMediaRepository: DwMediaRepositoryService,
    private dwMetaDataRoutingService: DwMetaDataRoutingService,
    private documentManagerService: DocumentsManagerService,
  ) {
  }

  ngOnInit(): void {
    this.setupCard();
    this.setupEditState();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data || changes.documentGroup || changes.parentFolder) {
      this.setupCard();
      this.setupEditState();
    }
  }

  cardTitle?: string;

  setupCard() {
    if (!this.data) {
      return;
    }

    switch (this.data.documentCardType) {
      case DocumentCardType.documentItem:
        this.setupDocumentCard();
        break;
      case DocumentCardType.folder:
        this.setupFolderCard();
        break;
    }
  }

  private setupEditState(): void {
    this.canEditItem = this.documentManagerService.canEditDocument(this.data, this.documentGroup, this.parentFolder);
  }


  setupDocumentCard() {
    const documentItem: DocumentItemsListQueryEntity = this.data?.documentItem;

    this.cardTitle = documentItem?.DocumentItemName;
    this.imageClass = '';
    if (documentItem.UseCustomCardIcon && documentItem.MediaMediaPath) {
      this.imageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(documentItem.MediaMediaPath, 400, 400);
    } else {
      if (documentItem.ExtractedMediaMediaPath) {
        this.imageUrl = this.dwMediaRepository.getImageUrlFromMediaPath(documentItem.ExtractedMediaMediaPath, 400, 400);
      }
    }

    if (!this.imageUrl) {
      this.imageUrl = '/assets/aviator-online/img/64px-PDF_file_icon.svg.png';
      this.imageClass = 'pdf-icon-image';
      this.pdfIconMaxSize = '100px';  // Set size for PDF icon only
    }
  }

  setupFolderCard() {
    const folder = this.data?.folderItem;

    this.cardTitle = folder?.FolderName;
    this.iconCss = 'fa fa-folder fa-5x';
  }

  click(event: Event): void {
    event.stopPropagation(); // Prevent card click from firing

    this.cardClick.emit(this.data);
  }

  // Click handler for ellipses button - opens the sheet
  configureClick(event: Event): void {

    event.stopPropagation(); // Prevent card click from firing

    this.cardConfigureClick.emit(this.data);

  }

}
